<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10 5.87491L4.1627 4.57773C3.69431 4.47365 3.25 4.83006 3.25 5.30988V14.2733C3.25 14.6248 3.49415 14.9292 3.8373 15.0054L10 16.3749M10 5.87491V16.3749M10 5.87491L11.4593 5.55062M10 16.3749L16.1627 15.0054C16.5059 14.9292 16.75 14.6248 16.75 14.2733V9.79158" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.3779 4.90203L15.8373 4.57773C16.3056 4.47365 16.7499 4.83006 16.7499 5.30988V6.4303V6.99051M16.3186 4.90203L12.9999 9" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ViewDocsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>